import * as React from 'react';
import { api, PortalContext } from '@portal/arq-portal-core';
import { makeStyles, TextField, Button, CircularProgress, Avatar, alpha
} from '@material-ui/core';
import { ElementoCompleto } from './ElementoCompleto';

const useStyles = makeStyles(theme => ({
  muroCompleto: {
      maxWidth: '90%',
      margin: '0 auto',
      padding: '15px',
      backgroundColor: '#fff'
  },
  linea: {
    padding: theme.spacing(1)
  },
  entry: {
    width: '100%',
    marginRight: '15px',
    border: 'none',
    marginBottom: '1.5rem',
    position: 'relative',
    minHeight: '105px',
    [`& textarea#entrada`]: {
      fontSize: '14px',
      minHeight: '105px',
    },
    [`& fieldset`]: {
      borderRadius: 0,
      minHeight: '105px'
    },
    [`& .MuiInputBase-root`]: {
      minHeight: '105px',
    },
  },
  publicarElemento: {
    width: '150px',
    background: '#606060',
    color: '#fff',
    borderRadius: '0',
    fontWeight: 'bold',
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    float: 'right',
    padding: '4px 8px',
    '&:hover': {
      backgroundColor: '#919191 !important'
    },
    '&.disabled': {
      color: '#fff'
    }
  },
  pubEntry: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-start',
    flexDirection: 'row',
  },
  contFoto: {
    width: '200px',
    marginBottom: '0',
    marginRight: '30px',
    padding: '0',
    display: 'block',
    backgroundColor: '#dc0028',
    [`& img`]: {
      width: '100%',
      height: 'auto',
      marginBottom: '0rem',
    },
    [`& .icon-estrella`]: {
      fontSize: '24px',
      color: '#fff'
    },
  },
  contProfileImg: {
    width: '100%',
    margin: 'auto',
    position: 'relative',
    height: '160px'
  },
  profileImgWrapper: {
    display: 'inline-block',
    margin: 'auto',
    position: 'absolute',
    top: '50%', left: '50%',
    transform: 'translate(-50%,-50%)',
    width:'42%'
  },
  userProfileAvatar: {
    height: "100%",
    width: "auto",
    margin: "auto",
    marginBottom : "0.5rem",
    color: theme.palette.primary.main,
    border: '3px solid #FFF',
    backgroundColor: alpha(theme.palette.primary.contrastText, 0.95),
  },
  userProfileAvatarDefault: {
    height: "80px",
    width: "80px",
    margin: "auto",
    marginBottom : "0.5rem",
    border: '3px solid #FFF',
    color: theme.palette.primary.main,
    backgroundColor: "rgba(250, 250, 250, 0.98)",
  },
  defaultIcon:{
    fontWeight: 'bold',
    fontSize: '4rem',
    marginBottom: 5
  },
  contInputs: {
    width: 'calc(100% - 230px)'
  },
  remember: {
    fontWeight: 'bold',
    marginBottom: '1.5rem',
    textAlign: 'initial',
    position: 'relative',
    fontFamily: 'Catalana-sans, Arial, sans-serif !important',
    color: '#807c7c',
    fontSize: '14px'
  },
  contTitulo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    [`& h1`]: {
      fontSize: '27px',
      fontWeight: 'bold',
      color: '#dc0028',
      margin: '1rem 0'
    },
    [`& i`]: {
      fontSize: '27px',
      cursor: 'pointer'
    }
  },
  contTabs: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [`& div`]: {
      color: '#606060',
      border: '1px solid #d6d8d8',
      fontWeight: 'bold',
      maxHeight: '37px',
      overflow: 'hidden',
      wordWrap: 'break-word',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
      verticalAlign: 'middle',
      textAlign: 'center',
      padding: '8px',
      cursor: 'pointer'
    },
    [`& .active`]: {
      borderTop: '4px solid #dc0028',
      borderBottom: '2px solid #fff',
    }
  },
  elements: {
    margin: '20px 0',
    backgroundColor: '#fff',
    minHeight: '100px'
  },
  contStars: {
    display: 'flex',
    justifyContent: 'center',
    [`& .star-filled`]: {
      color: '#fd0'
    }
  },
  iconCarga: {
    position: 'absolute',
    bottom: '0',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '10px',
  },
  elementsWrapper: {
    position: 'relative',
    width: '100%'
  },
  notificaciones: {
    textAlign: 'initial',
    position: 'absolute',
    top: '3rem',
    right: '1rem',
    width: '270px',
    padding: '0px',
    background: '#fff',
    borderRadius: '5px',
    margin: 'auto',
    zIndex: 3,
    boxShadow: '4px 4px 8px 0px rgba(0, 0, 0, 0.5)',
    color: '#606060',
    [`& p`]: {
      margin: '5px 0'
    },
    [`& .isRead`]: {
      backgroundColor: '#FFF !important'
    }
  },
  notifInd: {
    fontSize: '12px',
    cursor: 'pointer',
    transition: '.4s ease all',
    padding: '10px 10px 7px',
    borderBottom: '1px solid black',
    backgroundColor: '#EEEEEE',
    '&:hover': {
      backgroundColor: '#f4f4f4 !important'
    }
  },
  comName: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'start'
  },
  community: {
      width: 'auto',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexDirection: 'row',
      float: 'left',
      marginRight: '2rem',
      [`& span`]: {
          fontSize: '13px',
          color: '#606060',
          textTransform: 'capitalize',
      },
      [`& .COMM_AGENTES`]: {
          border: '2px solid #94ccda',
      },
      [`& .COMM_GENERALES`]: {
          border: '2px solid #f9d4b6',
      },
      [`& .COMM_VIDA`]: {
          border: '2px solid #cbc0d7',
      },
      [`& .COMM_COMUN`]: {
          border: '2px solid #c4bd98',
      },
      [`& .COMM_COMERCIAL`]: {
          border: '2px solid #d6e2be',
      },
  },
  comCircle: {
    display: 'block',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    marginRight: '5px',
    float: 'left',
  },
  spanNotification: {
    display: 'inline-block',
    minWidth: '10px',
    padding: '4px 9px',
    color: '#fff',
    verticalAlign: 'baseline',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    borderRadius: '13px',
    textShadow: 'none',
    lineHeight: '11px',
    backgroundColor: '#e85656',
    position: 'absolute',
    top: '-6px',
    right: '-15px',
    fontSize: '11px',
  },
  noMoreElements: {
    fontFamily: 'Catalana-sans, Arial, sans-serif !important',
    fontSize: '14px',
    color: '#606060',
    textAlign: 'center',
  },
  goBack: {
    display: 'flex',
    alignItems: 'center',
    [`& i`]: {
      fontSize: '30px'
    }
  },
  volver: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: '15px'
  },
  gcoBreadcrumb: {
    height: '30px',
    [`& i`]: {
      fontSize: '22px',
      marginRight: '-4px',
      marginLeft: '-4px',
    },
    [`& span`]: {
      position: 'relative',
      color: '#dc0028',
      fontFamily: 'CatalanaSans,Arial,sans-serif',
      fontSize: '12px',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        color: '#c0818f !important'
      }
    }
  },
  menuExitButton: {
    width: 'fit-content',
    marginTop: '4px',
    color: '#dc0028',
    paddingBottom: '0.2rem',
    fontFamily: 'CatalanaSans,Arial,sans-serif',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: '#c0818f !important'
    }
  },
  noEntradas: {
    fontSize: '14px',
    textAlign: 'center',
    margin: '25px 0 50px',
    fontFamily: 'Catalana-sans, Arial, sans-serif !important',
    color: '#606060'
  }
}));

export function MuroCompleto(props: any): JSX.Element {

  const classes = useStyles(props);
  const [notifCount, setNotifCount] = React.useState(0);
  const [currentUser] = React.useState(props.currentUser);
  const [openNotif, setOpenNotif] = React.useState(false);
  const [showMeInteresa, setShowMeInteresa] = React.useState(false);
  const [agentesComunityId] = React.useState(currentUser["Communities"].find((com: any) => (com.UniqueName == 'COMM_AGENTES'))?.CommunityId??"") 
  const [selectedCom, setSelectedCom] = React.useState(props.communityId);
  const [selectedElem, setSelectedElem] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const [pageMeInteresa, setPageMeInteresa] = React.useState(1);
  const [currentData, setCurrentData] = React.useState(new Array<any>());
  const [meInteresaData, setMeInteresaData] = React.useState(new Array<any>());
  const [notifData, setNotifData] = React.useState(new Array<any>());
  const [isLoadingScroll, setIsLoadingScroll] = React.useState(false);
  const [isLoadingCom, setIsLoadingCom] = React.useState(true);
  const [entryValue, setEntryValue] = React.useState('');
  const [error, setError] = React.useState<any>(null);
  const { user, ciaGestiona } = React.useContext(PortalContext);

  var urlParams = new URLSearchParams(window.location.search);
  var ciaUrl = urlParams.get('cia');
  let cia = (ciaUrl === 'SCO' || ciaUrl === 'SBI' || ciaUrl === 'SPU') ? ciaUrl : ciaGestiona;

  // Actualizar contador de notificaciones cuando cambia el currentUser
  const updateNotifCount = () => {
    let count = 0;
    currentUser && currentUser["Notifications"].length > 0 && currentUser["Notifications"].forEach((notif: any) => {
      if(notif.IsRead == false){
       count++;
      }
    });
    setNotifCount(count);
  }

  const isDateOverOneYearOld = (dateString: string) => {
    var givenDate = new Date(dateString);
    var currentDate = new Date();
    var oneYearLater = new Date(givenDate.getFullYear() + 1, givenDate.getMonth(), givenDate.getDate());
  
    return oneYearLater <= currentDate;
  }
  

  // Obtener elementos actualizados / siguiente página / comunidad
  const updateData = (currentPage:any, selectedCommunity:any) => {
    api.post('/be/piupointgetwallelements/',{"Entrada":{"cia": cia,"page":currentPage.toString(),"pageSize":'10',"communityId":selectedCommunity.toString(),"isMockup":false,"mockupStateElementComment":''}})
      .then((data) => {
        let newData = data?.Salida?.response?JSON.parse(data.Salida.response) : [];

        if(currentPage == 1){
          let isOverOneYearOld = newData[0] && isDateOverOneYearOld(newData[0].CreationDate);
          if(isOverOneYearOld && selectedCommunity === agentesComunityId){
            setCurrentData([]);
          }else{
            setCurrentData(newData);
          }
        }else{
          setCurrentData(currentData.concat(newData));
        }
        setIsLoadingCom(false);
        setIsLoadingScroll(false);
      }).catch((err:any) =>
        { setError(err) }
      );
  }

  // Función que detecta que se ha llegado al final de la página y carga más elementos
  const handleScroll = () => {
    // Solo scroll en el muro principal, no en el detalle de la notificación
    if(!isLoadingScroll && !selectedElem){
      if(window.scrollY + window.innerHeight >= document.documentElement.scrollHeight){
        if(showMeInteresa){
          if(meInteresaData && meInteresaData.length > 0 && meInteresaData[0].WallElementsPageCount > pageMeInteresa){
            //console.log('scroll me int ' + (pageMeInteresa+1));
            setIsLoadingScroll(true);
            setPageMeInteresa(pageMeInteresa + 1);
          }
        }else{
          if(currentData && currentData.length > 0 && currentData[0].WallElementsPageCount > page){
            //console.log('scroll ' + (page+1));
            setIsLoadingScroll(true);
            setPage(page + 1);
          }
        }
        window.removeEventListener('scroll', handleScroll);
      }
    }
  };

  // Mostrar el detalle del elemento al clicar en una notificación
  const handleNotifDetail = (elem: any) => {
    setOpenNotif(false);
    if (!elem.IsRead) {
      api.post('/be/piupointreadnotification/',{"Entrada":{"cia": cia,"json": JSON.stringify({ NotificationId: elem.NotificationId }),"isMockup":false}});
    }
    api.post('/be/piupointgetwallelementdetail/',{"Entrada":{"wallContentId": elem.WallElementId,"cia": cia,"isMockup":false}}).then((data) => {
      let notifItemDetail = data?.Salida?.response?JSON.parse(data.Salida.response) : [];
      let notifItemData = [];
      notifItemData.push(notifItemDetail);
      setNotifData(notifItemData);
    });
  }

  // Mostrar elementos en los cuales el usuario ha hecho algún like
  const updateMeInteresaData= (currentPage:any) => {
    api.post('/be/piupointgetwallelementsliked/',{"Entrada":{"page":currentPage.toString(),"pageSize":"10","cia": cia,"isMockup":false}}).then((data) => {
      let meInteresaContent = data?.Salida?.response?JSON.parse(data.Salida.response) : [];
      if(currentPage == 1){
        setMeInteresaData(meInteresaContent);
      }else{
        setMeInteresaData(meInteresaData.concat(meInteresaContent));
      }
      setIsLoadingCom(false);
      setIsLoadingScroll(false);
    }).catch((err:any) =>
      { setError(err) }
    );
  }

  const handleMeInteresa = () => {
    // console.log('b4 set page ' + pageMeInteresa.toString());
    setPageMeInteresa(1);
    // console.log('after set page ' + pageMeInteresa.toString());
    setIsLoadingCom(true);
    updateMeInteresaData(1);
  }

  // Obtener datos actualizados cuando cambia la página o la comunidad seleccionada
  React.useEffect(() => {
    // console.log('effect update pageMeInteresa: '+ pageMeInteresa.toString() );
    if(pageMeInteresa != 1){
      updateMeInteresaData(pageMeInteresa);
    }
  }, [pageMeInteresa]);

  React.useEffect(() => {
      // console.log('effect update page - page:'+ page.toString() +"  commId:"+selectedCom.toString());
      if(page != 1){
        updateData(page,selectedCom);
      }
  }, [page]);

  React.useEffect(() => {
    // console.log('effect update comm - page:'+ page.toString() +"  commId:"+selectedCom.toString());
    setPage(1);
    updateData(1,selectedCom);
  }, [selectedCom]);

  React.useEffect(() => {
    updateNotifCount();
  }, [currentUser]);

  // Añadir eventlistener del scroll solo una vez
  window.addEventListener('scroll', handleScroll);

  // Eliminar elemento del muro
  const deleteElement = (event: any, ElementId: number) => {
    event.stopPropagation();

    let jsonLike = {
        ContentId: ElementId,
    };

    api.post('/be/piupointdeletewallelement/', {"Entrada": {"json": JSON.stringify(jsonLike), "cia": cia}}).then(() => {
        updateData(page,selectedCom);
        if(showMeInteresa){
          updateMeInteresaData(page);
        }
    });
  };

  // Publicar nueva entrada en el muro
  const publishEntry = () => {
    let jsonNew = {
      Title: "",
      Body: entryValue,
      AllowComments: true,
      Type: "",
      PreviewThumbnailUrl: "",
      PreviewTitle: "",
      PreviewBody: "",
      PreviewUrl: "",
      PreviewUrlOriginal: "",
      Communities: [agentesComunityId],
    };

    api.post('/be/piupointcreatewallelement/', {"Entrada": {"json": JSON.stringify(jsonNew), "cia": cia}}).then(() => {
      updateData(page,selectedCom);
      setEntryValue('');
    });
  };

  // Abrir cuadro de notificaciones
  const openNotifs = () => {
    setOpenNotif(!openNotif);
  }

  // Modificar valor del textbox de la nueva entrada en el muro
  const handleTextChange = (event: any) => {
    setEntryValue(event.target.value);
  };

  // Calcular hace cuánto tiempo se realizó la entrada/comentario
  const notifTime = (notif: any) => {
    let today = new Date();
    // Añadir Z para pasar de UTC a timezone actual
    let created = new Date(notif?.CreationDate + 'Z');
    let hours = 0;
      let minutes = 0;
      let days = 0;
      let month = 0;
      let years = 0;

      const timeDiff = today.getTime() - created.getTime();
      minutes = Math.floor(timeDiff / (1000 * 60));
      hours = Math.floor(timeDiff / (1000 * 60 * 60));
      days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      month = (today.getMonth() + 1) - (created.getMonth() + 1) + (12 * (today.getFullYear() - created.getFullYear()));
      years = today.getFullYear() - created.getFullYear();

      if (minutes < 60) {
          return ` ${minutes === 1 ? 'un' : `${minutes}`} minuto${minutes === 1 ? '' : 's'}`;
      } else if (hours < 24) {
          return ` ${hours === 1 ? 'una' : `${hours}`} hora${hours === 1 ? '' : 's'}`;
      } else if (days < 30) {
          return ` ${days === 1 ? 'un' : `${days}`} día${days === 1 ? '' : 's'}`;
      } else if (month < 12) {
          return ` ${month === 1 ? 'un' : `${month}`} mes${month === 1 ? '' : 'es'}`;
      } else {
          return ` ${years === 1 ? 'un' : `${years}`} año${years === 1 ? '' : 's'}`;
      }
  }

  return (<React.Fragment>
        <div className={classes.muroCompleto}>

          <div className={classes.gcoBreadcrumb}>
            <a href="javascript:history.back()" id="__salir__" className={classes.menuExitButton}>
              <i className="icon-flecha-izq"></i>
              <span>Volver</span>
            </a>
          </div>

            {currentUser && currentUser["Communities"]?.length > 0 && currentUser["Communities"].find((com: any) => (com.UniqueName == 'COMM_AGENTES' && com.Permissions.CanCreate)) &&
              <div className={classes.pubEntry}>
                  <div className={classes.contFoto}>
                    <div className={classes.contProfileImg}>
                      <div className={classes.profileImgWrapper}>
                        <Avatar variant="circular" className={ user?.foto !== null ? classes.userProfileAvatar:classes.userProfileAvatarDefault} src={user?.foto !== null ? api.getApiServer() + user?.foto : ""}>
                            <i className={`icon-contactos ${classes.defaultIcon}`}></i>
                        </Avatar>
                        <div className={classes.contStars}>
                          <i className={`icon-estrella ${currentUser && currentUser["Score"] > 0? `star-filled` : ``}`}></i>
                          <i className={`icon-estrella ${currentUser && currentUser["Score"] > 1? `star-filled` : ``}`}></i>
                          <i className={`icon-estrella ${currentUser && currentUser["Score"] > 2? `star-filled` : ``}`}></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={classes.contInputs}>
                      <div className={classes.remember}>
                        Recuerde que se publicará en Agentes
                      </div>

                      <TextField {...props} id="entrada" placeholder="¿Qué hay de nuevo?" variant="outlined" size="small" multiline
                          className={classes.entry}
                          value={entryValue}
                          onChange={handleTextChange}
                      />

                      <Button disabled={entryValue === ''} variant="text" onClick={publishEntry} className={`${classes.publicarElemento} ${entryValue === '' ? `disabled` : ``}`}>
                          Publica
                      </Button>
                  </div>
              </div>
            }

            {(selectedElem || showMeInteresa) &&
              <div className={classes.goBack} onClick={() => {location.reload()}}>
                <i className="icon-flecha-izq"></i>
                <a  className={classes.volver}>Volver a foro </a>
              </div>
            }

            <div className="widget-content">
                <div className={classes.contTitulo}>
                    {selectedElem ?
                      <h1>Notificaciones</h1>
                    : showMeInteresa ?
                      <h1>Me interesa</h1>
                    :
                      <h1>Últimas noticias</h1>
                    }

                    {!selectedElem && !showMeInteresa &&
                      <div>
                        <i className="icon-pro-like" onClick={() => { setShowMeInteresa(true); handleMeInteresa();}}></i>
                        <i className="icon-campana" onClick={openNotifs}>
                          {currentUser["Notifications"]?.length > 0 && notifCount > 0 &&
                            <span className={classes.spanNotification}>{notifCount}</span>
                          }
                        </i>
                      </div>
                    }

                    {openNotif && currentUser && currentUser["Notifications"]?.length > 0 &&
                        <div className={classes.notificaciones}>
                          {currentUser["Notifications"].map((elem: any, index: any) => {
                            return (<div key={index} className={`${classes.notifInd} ${elem.IsRead ? `isRead` : ``}`} onClick={ () => { setSelectedElem(elem.WallElementId); handleNotifDetail(elem); }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                                <div className={classes.community}>
                                  <i className={`${classes.comCircle} ${elem.Communities[0]?.UniqueName}`}></i>
                                  <span>{elem.Communities[0]?.Name}</span>
                                </div>
                                <div style={{fontSize: '10px'}}>hace {notifTime(elem)}</div>
                              </div>
                              <p style={{fontWeight: 'bold', color: '#606060'}}>
                                {elem.NotificatorUserName}
                              </p>
                              {elem.NotificationType == "COMMENT" ?
                                <p>ha comentado en tu publicación</p>
                                : elem.NotificationType == "LIKE" &&
                                <p>le ha gustado tu publicación</p> }
                            </div>)
                          })}
                        </div>
                    }
                </div>

                {!selectedElem && !showMeInteresa &&
                  <div className={classes.contTabs}>
                      {currentUser && currentUser["Communities"]?.length > 0 && currentUser["Communities"].map((com: any, index: any) => {
                          return (<div key={index} className={`${selectedCom == com.CommunityId && `active`}`} onClick={ () => {
                            setIsLoadingCom(true); setCurrentData([]);
                            setSelectedCom(com.CommunityId); }}>{com.Name}</div>)
                      })}
                  </div>
                }

                {!error && (isLoadingCom || meInteresaData.length > 0 || notifData.length > 0 || currentData.length > 0) &&
                  <div className={classes.elements}>
                    <div className={classes.elementsWrapper}>
                      {isLoadingCom ?
                        <div className={classes.iconCarga} style={{bottom: '-70px'}}>
                          <CircularProgress color="primary" size={26} thickness={3} />
                        </div>
                      : showMeInteresa ?
                        meInteresaData && meInteresaData.map((el: any, index: any) => {
                          return (<ElementoCompleto key={index} elemento={el} elementos={currentData?.length} selectedcom={selectedCom} agentesComunityId={agentesComunityId} deleteelement={deleteElement}/>)
                        })
                      :
                      selectedElem ?
                        notifData && notifData.map((el: any, index: any) => {
                          return (<ElementoCompleto key={index} elemento={el} elementos={currentData?.length} selectedcom={selectedCom} agentesComunityId={agentesComunityId}deleteelement={deleteElement}/>)
                        })
                      :
                        currentData && currentData.map((el: any, index: any) => {
                          return (<ElementoCompleto key={index} elemento={el} elementos={currentData?.length} selectedcom={selectedCom} agentesComunityId={agentesComunityId} deleteelement={deleteElement}/>)
                        })
                      }

                      {showMeInteresa && !isLoadingCom &&
                        <div className={classes.noMoreElements}>No hay más elementos para mostrar</div>
                      }

                      <div className={classes.iconCarga}>
                        {isLoadingScroll && !isLoadingCom &&
                          <CircularProgress color="primary" size={16} thickness={2} /> }
                      </div>
                    </div>
                  </div>
                }
            </div>

    {!error && !isLoadingCom && (!currentData || currentData.length == 0) && <div className={classes.noEntradas}>No hay entradas para mostrar</div>}
    {error && error.message && !currentData && <div className={classes.noEntradas}>{error.message}</div>}
    {error && !error.message && !currentData && <div className={classes.noEntradas}>Datos no disponibles en estos momentos</div>}
    </div>
  </React.Fragment>
  )
}